module.exports = __webpack_public_path__ + "assets/img/23_24_big.54fbabd1.jpg";